/* Austritts-Angebot.

   Auslegung der Ausloeser:
   - Desktop: mouseleave am oberen Rand. Das klassische Exit-Intent-Signal.
   - Mobil: mouseleave existiert dort nicht. Ersatz ist ein Eintrag in der
     History, der den Zurueck-Button einmal abfaengt. Bewusst nur einmal,
     danach funktioniert Zurueck wieder normal.

   Zwei Bedingungen muessen erfuellt sein, bevor ueberhaupt scharfgestellt
   wird: der Besucher hat in dieser Sitzung eine Produktseite gesehen, und
   es gab eine echte Eingabe (Maus, Tastatur, Beruehrung, Scrollen). Der
   zweite Punkt haelt Crawler draussen — rund zwei Drittel der Sitzungen
   dieses Shops stammen aus Rechenzentren und wuerden die Auswertung sonst
   unbrauchbar machen. */

(function () {
  'use strict';

  var root = document.querySelector('[data-pebbl-exit-offer]');
  if (!root) return;

  var SEEN_PRODUCT_KEY = 'pebbl:seen-product';
  var SHOWN_KEY = 'pebbl:exit-offer-shown';

  /* Konfiguration kommt aus den Theme-Einstellungen ueber data-Attribute. */
  var SUPPRESS_DAYS = parseInt(root.dataset.suppressDays, 10) || 14;
  var REQUIRE_PRODUCT = root.dataset.requireProduct !== 'false';

  /* Produktseitenbesuch merken. Sitzungsweit, nicht dauerhaft: das
     Angebot soll sich auf den aktuellen Besuch beziehen. */
  if (root.dataset.isProductPage === 'true') {
    try {
      sessionStorage.setItem(SEEN_PRODUCT_KEY, '1');
    } catch (e) {
      /* Privater Modus: dann greift das Angebot in dieser Sitzung nicht. */
    }
  }

  function hasSeenProduct() {
    try {
      return sessionStorage.getItem(SEEN_PRODUCT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function recentlyShown() {
    try {
      var ts = parseInt(localStorage.getItem(SHOWN_KEY) || '0', 10);
      if (!ts) return false;
      return Date.now() - ts < SUPPRESS_DAYS * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function markShown() {
    try {
      localStorage.setItem(SHOWN_KEY, String(Date.now()));
    } catch (e) {
      /* ohne Speicher kein Merken — dann eben erneut beim naechsten Mal */
    }
  }

  if (REQUIRE_PRODUCT && !hasSeenProduct()) return;
  if (recentlyShown()) return;

  var dialog = root.querySelector('.pebbl-exit-offer__dialog');
  var lastFocused = null;
  var isOpen = false;
  var armed = false;

  function open() {
    if (isOpen || recentlyShown()) return;
    isOpen = true;
    markShown();
    lastFocused = document.activeElement;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    if (dialog) dialog.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') close();
  }

  function accept() {
    var code = root.dataset.discountCode;
    var back = window.location.pathname + window.location.search;
    /* Shopify setzt den Code ueber diese Route auf die Sitzung und leitet
       anschliessend zurueck — der Kunde muss nichts abtippen. */
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  }

  root.querySelectorAll('[data-exit-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  var acceptBtn = root.querySelector('[data-exit-accept]');
  if (acceptBtn) acceptBtn.addEventListener('click', accept);

  /* Erst nach echter Eingabe scharfstellen. */
  function arm() {
    if (armed) return;
    armed = true;

    document.addEventListener('mouseleave', function (event) {
      if (event.clientY <= 0) open();
    });

    var isTouch = window.matchMedia('(pointer: coarse)').matches;
    if (isTouch) {
      try {
        history.pushState({ pebblExitGuard: true }, '');
        window.addEventListener('popstate', function handler(event) {
          window.removeEventListener('popstate', handler);
          if (!isOpen && !recentlyShown()) {
            open();
          }
        });
      } catch (e) {
        /* History gesperrt: dann bleibt es auf Mobil beim Zurueck-Button */
      }
    }
  }

  ['mousemove', 'keydown', 'touchstart', 'scroll'].forEach(function (evt) {
    document.addEventListener(evt, arm, { once: true, passive: true });
  });
})();
